import {
  ChartSeries, ChartUnit, GraphData, GraphRow, IEnergies,
} from '@app/@types/myEnergy'
import { ChartBucket, Period } from '@app/lib/MyEnergy/intervalValues'
import getDatesForWeekPeriod from './getDatesForWeekPeriod'
import getMonthsForPeriod from './getMonthsForPeriod'

const getData = (
  pointsArray: GraphData,
  currentChart: ChartSeries,
  type: ChartBucket,
  annotation: GraphRow,
): GraphData => {
  const period = pointsArray.map((point, index) => {
    point.push(currentChart[type][index])
    return point
  })
  period.unshift(annotation)
  return period
}

const weekPeriod = (currentChart: ChartSeries): GraphData => {
  const weekDaysArr = getDatesForWeekPeriod()
  return getData(weekDaysArr, currentChart, 'week', ['Day', 'amount'])
}

const monthPeriod = (currentChart: ChartSeries): GraphData => {
  const monthWeeksArr: GraphData = [['1st week'], ['2nd week'], ['3rd week'], ['4th week']]
  return getData(monthWeeksArr, currentChart, 'month', ['Week', 'amount'])
}

const sixMonthPeriod = (energies: IEnergies, currentChart: ChartSeries, period: Period): GraphData => {
  const sixMonthArr = getMonthsForPeriod(energies.current_time, period)
  return getData(sixMonthArr, currentChart, 'half_year', ['SixMonth', 'amount'])
}

const yearPeriod = (energies: IEnergies, currentChart: ChartSeries, period: Period): GraphData => {
  const yearMonthsArr = getMonthsForPeriod(energies.current_time, period)
  return getData(yearMonthsArr, currentChart, 'year', ['Year', 'amount'])
}

const getDataForGraph = (period: Period, energies: IEnergies, unit: ChartUnit): GraphData => {
  const currentChart = energies.chart[unit]

  switch (period) {
  case 'last_week_period':
    return weekPeriod(currentChart)
  case 'last_month_period':
    return monthPeriod(currentChart)
  case 'last_6_month_period':
    return sixMonthPeriod(energies, currentChart, period)
  case 'last_year_period':
    return yearPeriod(energies, currentChart, period)
  default:
    return weekPeriod(currentChart)
  }
}

export default getDataForGraph
